const Immutable = require('immutable')
const {
  keyedReviver
} = require('client-v2/common/state/revivers')

class SMSModalDeeplinkRecord extends Immutable.Record({
  'deeplink_url': String(),
  'deeplink_path': String()
}) {
  // No methods
}

SMSModalDeeplinkRecord.reviver = keyedReviver(SMSModalDeeplinkRecord, {
})

class SMSModalRecord extends Immutable.Record({
  // Values
  deeplinkData: null,
  // Flags
  isSubmitFailed: Boolean(),
  isSubmitSuccessful: Boolean(),
  isVisible: Boolean(),
  isDownloadPromptVisible: Boolean()
}) {
  // No methods
}

SMSModalRecord.reviver = keyedReviver(SMSModalRecord, {
  deeplinkData: SMSModalDeeplinkRecord.reviver
})

module.exports = SMSModalRecord
